import Plyr from "plyr";

interface AudioPlayerDetailCallbacks {
    created?: (instance: AudioPlayerDetail) => any,
    played?: (instance: AudioPlayerDetail) => any,
}

class AudioPlayerDetail {

    protected playlist = [];
    protected currentTrack = 0;
    protected audioPlayer;

    public isPlaying = false;

    constructor(protected playerContainer, protected audioPlaceholder, protected callbacks?: AudioPlayerDetailCallbacks) {
        const customRangeElement = this.playerContainer.find('.custom-range');

        if (customRangeElement.length > 0) {
            this.customRange(customRangeElement);
        }

        this.playerContainer
            .on('input', '.custom-range', (e) => this.customRange(e.currentTarget))
            .on('click', '.audio-sound-range', this.soundRange.bind(this))
            .on('click', '.podcasts-play-btn', this.playClicked.bind(this))
            .on('click', '.btn-prev', this.backward.bind(this))
            .on('click', '.btn-next', this.forward.bind(this));

        if (this.callbacks?.created) {
            this.callbacks.created(this);
        }
    }

    protected playClicked() {
        if (this.isPlaying) {
            this.pause()
        } else {
            this.play()
        }
    }

    public play() {
        if (!this.audioPlayer) {
            this.loadFile();
        }

        if (this.audioPlayer.paused) {
            this.audioPlayer.play();
            this.updatePlayBtnIcon();
        }
    }

    public pause() {
        if (this.audioPlayer && !this.audioPlayer.paused) {
            this.audioPlayer.pause();
            this.updatePlayBtnIcon();
        }
    }

    protected updatePlayBtnIcon() {
        const playButton = this.playerContainer.find('.podcasts-play-btn');

        if (!this.audioPlayer) {
            playButton.addClass('audio-played');
        }

        this.isPlaying = !this.audioPlayer.paused;

        if (this.isPlaying) {
            playButton.addClass('audio-played');
        } else {
            playButton.removeClass('audio-played');
        }
    }

    public loadFile() {
        const audioSrc = this.playerContainer.find('.audio-file').val();

        if (!audioSrc) {
            return;
        }

        this.audioPlaceholder.prepend(new Audio(audioSrc));

        if (this.audioPlayer) {
            this.audioPlayer.destroy();
        }

        this.audioPlayer = new Plyr(this.audioPlaceholder.find('audio').get(0), {
            debug: false,
            controls: ['current-time', 'progress', 'duration']
        });

        if (this.callbacks?.played) {
            this.audioPlayer.on('ended', () => this.callbacks?.played(this));
        }

        if (this.isPlaying) {
            this.play();
        }

        this.updatePlayBtnIcon();
    }

    forward() {
        this.audioPlayer.forward(15);
    }

    backward() {
        this.audioPlayer.forward(-15);
    }

    soundRange(e) {
        this.audioPlayer.volume = parseFloat($(e.currentTarget).val().toString()) / 100;
    }

    customRange(e) {
        $(e).css('--value', $(e).val().toString() + '%');
    }

}

export default AudioPlayerDetail;